import React from 'react';
import SuperAdminLayout from '../../components/admin/SuperAdminLayout';
import ProjectsManagement from '../../components/admin/ProjectsManagement';

const ProjectsPage: React.FC = () => {
  return (
    <SuperAdminLayout>
      <ProjectsManagement />
    </SuperAdminLayout>
  );
};

export default ProjectsPage;
